import { useRouter } from '@nuxtjs/composition-api';

import { useMagentoConfiguration } from '~/composables';
import { removeDomain } from '~/helpers/productHelpers';

import { UseHtmlRouterInterface } from './useHtmlRouter';

export function useHtmlRouter(): UseHtmlRouterInterface {
  const { magentoBaseUrl } = useMagentoConfiguration();
  const router = useRouter();

  const addDynamicRoutes = (blockSelector: string): void => {
    const blockElement = document.querySelector(blockSelector);

    if (!blockElement) return;

    const links = blockElement.querySelectorAll('a');

    if (links.length === 0) return;

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const href = removeDomain(link.getAttribute('href'), magentoBaseUrl.value);
        router.push(href);
      });
    });
  };

  return {
    addDynamicRoutes,
  };
}
